module.exports = __webpack_public_path__ + "img/advanced5.9457de8b.png";